import {
  type ViewExtensionContext,
  ViewExtensionProvider,
} from '@blocksuite/affine-ext-loader';

import { effects } from './effects';

export class TemplateViewExtension extends ViewExtensionProvider {
  override name = 'affine-template-view';

  override effect(): void {
    super.effect();
    effects();
  }

  override setup(context: ViewExtensionContext) {
    super.setup(context);
    // Template button removed from edgeless toolbar
  }
}
